export default __webpack_public_path__ + "static/media/people.8a3dd3ba.svg";